"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownFooterButton = exports.DropdownFooter = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _ButtonGroup = _interopRequireDefault(require("@eig-builder/core-ui/ButtonGroup"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  height: 56px;\n  margin-bottom: -8px;\n  margin-top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 102%; /* Make up for double borders */\n  margin-left: -2px; /* Make up for double borders */\n  border-top-left-radius: 0 !important;\n  height: ", ";\n  border-top-right-radius: 0 !important;\n  border: ", " !important;\n  border-bottom: none !important;\n  color: ", " !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DropdownFooterButton = (0, _styledComponents["default"])(_Button["default"])(_templateObject(), function (_ref) {
  var height = _ref.height;
  return height || '48px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.palette.black.lighter);
}, function (_ref3) {
  var disabled = _ref3.disabled,
      theme = _ref3.theme;
  return getcolor(theme, disabled);
});
exports.DropdownFooterButton = DropdownFooterButton;
var StyledButtonGroup = (0, _styledComponents["default"])(_ButtonGroup["default"])(_templateObject2(), function (props) {
  return props.theme.spacing(2);
});

var getcolor = function getcolor(theme) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (disabled) {
    return theme.palette.primary.background; // light blue
  }

  return theme.palette.primary.main; // blue
};

var DropdownFooter = function DropdownFooter(_ref4) {
  var children = _ref4.children;

  if (children) {
    return /*#__PURE__*/_react["default"].createElement(StyledButtonGroup, {
      size: "fullWidth",
      "aria-label": "dropdown menu buttons"
    }, children);
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", null);
  }
};

exports.DropdownFooter = DropdownFooter;
DropdownFooter.propTypes = {
  children: _propTypes["default"].any.isRequired
};